define('request-context',["jquery", "i18n"], function ($, i18n) {
    "use strict";

    function headers() {
        return {
            "X-VeggieZone-Country": i18n.country,
            "X-VeggieZone-Language": i18n.locale.split(/[-_]/)[0]
        };
    }

    function isApiRequest(url) {
        try {
            var target = new URL(url, window.location.href);
            if (!/^\/api\//i.test(target.pathname)) return false;
            if (target.origin === window.location.origin) return true;
            var apiBase = window.localStorage.getItem("VeggieZoneBaseUrl");
            return !!apiBase && target.origin === new URL(apiBase, window.location.href).origin;
        } catch (ignored) {
            return false;
        }
    }

    // Includes Select2 and other jQuery callers that do not use api.call().
    // Only the application API receives these headers, never third-party requests.
    $.ajaxPrefilter(function (options) {
        if (isApiRequest(options.url))
            options.headers = $.extend({}, headers(), options.headers);
    });

    return { headers: headers };
});

